var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.097,
    height: 13.126,
    viewBox: "0 0 10.097 13.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-document",
    "data-name": "Icon ionic-md-document",
    d: "M12.808,3.375h-4.8A1.262,1.262,0,0,0,6.75,4.637v10.6A1.262,1.262,0,0,0,8.012,16.5h7.573a1.262,1.262,0,0,0,1.262-1.262V7.414Zm-.5,4.544V4.385l3.534,3.534Z",
    transform: "translate(-6.75 -3.375)",
    fill: "#716f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.c3c1efde8120c38fc6e29093a7fd4dc4.svg";
export { ForwardRef as ReactComponent };